import { Component, inject } from '@angular/core';
import { OpenCartsListConfigService } from '../../services/open-carts-list-config/open-carts-list-config.service';

@Component({
  selector: 'lib-open-carts',
  standalone: false,
  templateUrl: './open-carts.component.html',
  styleUrl: './open-carts.component.scss'
})
export class OpenCartsComponent {

  public openCartsListConfigService = inject(OpenCartsListConfigService);

}
